import React from "react";

import {
  SearchBarContainer,
  SearchBarTitle,
  SearchNTagContainer,
  SearchNTagSec,
  TagContainer,
  TagContainerHeader,
} from "./styles";
import BarraDePesquisa from "../../../BarraDePesquisa";
import { ListaCategorias } from "./ListaCategorias";

function BarraDePesquisaECategorias({
  setPesquisa = () => {},
  setCategoria = () => {},
  categoria,
  listaCategorias = [],
}) {
  return (
    <SearchNTagSec>
      <SearchNTagContainer>
        <TagContainer>
          <TagContainerHeader hidden={listaCategorias.length === 0}>
            Categorias
          </TagContainerHeader>
          <ListaCategorias
            currentCategory={categoria}
            setCategory={setCategoria}
            listCategory={listaCategorias}
          />
        </TagContainer>
        <SearchBarContainer>
          <SearchBarTitle>Pesquisar</SearchBarTitle>
          <BarraDePesquisa setState={setPesquisa} />
        </SearchBarContainer>
      </SearchNTagContainer>
    </SearchNTagSec>
  );
}

export default BarraDePesquisaECategorias;
